module.exports = __webpack_public_path__ + "img/227fd31.png";